"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = void 0;
const get_zaraz_1 = require("./helpers/get-zaraz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function set(key, value, options) {
    (0, get_zaraz_1.getZaraz)().set(key, value, options);
}
exports.set = set;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3NldC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBK0M7QUFFL0MsOERBQThEO0FBQzlELFNBQWdCLEdBQUcsQ0FBQyxHQUFXLEVBQUUsS0FBVSxFQUFFLE9BQWE7SUFDeEQsSUFBQSxvQkFBUSxHQUFFLENBQUMsR0FBRyxDQUFDLEdBQUcsRUFBRSxLQUFLLEVBQUUsT0FBTyxDQUFDLENBQUM7QUFDdEMsQ0FBQztBQUZELGtCQUVDIn0=